import React from "react";
import ReactMarkdown from "react-markdown";
import "./MarkdownRenderer.css";

/**
 * Renders markdown content with proper formatting.
 * Used across StudyHub to display AI-generated or user-written markdown content.
 *
 * @param {string} content - The markdown string to render
 * @param {string} className - Optional additional CSS class
 * @param {boolean} preview - If true, renders a truncated plain-text preview (for cards)
 * @param {number} previewLength - Max characters for preview mode (default 150)
 */
const MarkdownRenderer = ({
  content,
  className = "",
  preview = false,
  previewLength = 150,
}) => {
  if (!content) return null;

  // For card previews, strip markdown and truncate
  if (preview) {
    const plainText = content
      .replace(/#{1,6}\s+/g, "") // headings
      .replace(/\*\*(.+?)\*\*/g, "$1") // bold
      .replace(/\*(.+?)\*/g, "$1") // italic
      .replace(/__(.+?)__/g, "$1") // bold alt
      .replace(/_(.+?)_/g, "$1") // italic alt
      .replace(/`{3}[\s\S]*?`{3}/g, "") // code blocks
      .replace(/`(.+?)`/g, "$1") // inline code
      .replace(/\[(.+?)\]\(.+?\)/g, "$1") // links
      .replace(/^[-*+]\s+/gm, "") // list markers
      .replace(/^\d+\.\s+/gm, "") // ordered list markers
      .replace(/^>\s+/gm, "") // blockquotes
      .replace(/---+/g, "") // horizontal rules
      .replace(/\n{2,}/g, " ") // collapse multiple newlines
      .replace(/\n/g, " ") // single newlines to spaces
      .trim();

    const truncated =
      plainText.length > previewLength
        ? plainText.slice(0, previewLength) + "…"
        : plainText;

    return <p className={`markdown-preview ${className}`}>{truncated}</p>;
  }

  return (
    <div className={`markdown-rendered ${className}`}>
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
